import { Spin, Row, Col, Avatar, Statistic, Alert, Result, Divider } from "antd";
import { observer } from "mobx-react";
import { useEffect, useState } from "react";
import { _i, __ } from "../../../utils";
import { useStores } from "../../../store";
import { RealCommerceError } from "../../../exceptions";
import { useRealCommerceErrorHandling } from "../../../hooks";
import { useParams } from "react-router-dom";
import { ChangePaymentDetailsForm } from "..";
const AccountExpiredPaymentDetails = observer(() => {
  const {
    uuid: subscriptionUuid
  } = useParams();
  const [busy, setBusy] = useState(false);
  const [updated, setUpdated] = useState(false);
  const [error, setError] = useState();
  const handleRealCommerceError = useRealCommerceErrorHandling();
  const {
    accountStore
  } = useStores();
  const {
    expiredPaymentDetailsSubscription
  } = accountStore;

  // Load the failed payment detail
  useEffect(() => {
    (async () => {
      try {
        setBusy(true);
        await accountStore.fetchPaymentFailedDetails(subscriptionUuid);
      } catch (e) {
        if (e instanceof RealCommerceError) {
          if (e.codes.length) {
            setError(e);
          } else {
            handleRealCommerceError(e);
          }
        }
      } finally {
        setBusy(false);
      }
    })();
  }, [subscriptionUuid]);
  return /*#__PURE__*/React.createElement(Spin, {
    spinning: busy
  }, !!expiredPaymentDetailsSubscription && (() => {
    const {
      data: {
        productPlan: {
          product: {
            name,
            logo: {
              downloadUrl: logo
            }
          },
          description
        }
      }
    } = expiredPaymentDetailsSubscription;
    return /*#__PURE__*/React.createElement(Row, {
      align: "middle"
    }, logo && /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Avatar, {
      src: logo,
      size: 60,
      shape: "square",
      style: {
        marginRight: 15
      }
    })), /*#__PURE__*/React.createElement(Col, {
      style: {
        lineHeight: "24px"
      }
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        fontSize: 12
      }
    }, __("Change payment method for")), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("span", {
      style: {
        fontSize: 25,
        fontWeight: "bold"
      }
    }, name)), /*#__PURE__*/React.createElement(Col, {
      style: {
        marginLeft: "auto",
        textAlign: "right"
      }
    }, /*#__PURE__*/React.createElement(Row, {
      gutter: [20, 20],
      justify: "end",
      style: {
        marginBottom: 0
      }
    }, !!description && /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Statistic, {
      title: __("Plan"),
      value: description
    })))));
  })(), updated ? /*#__PURE__*/React.createElement(Result, {
    title: __("Payment method updated!"),
    subTitle: _i(__("Thanks for updating your payment method. {{strong}}Your subscription will continue!{{/strong}} All future payments for this subscription will be debited from the payment method you have just entered."), {
      strong: /*#__PURE__*/React.createElement("strong", null)
    }),
    status: "success"
  }) : error ? /*#__PURE__*/React.createElement(Result, {
    subTitle: error.message,
    status: error.hasErrorCode("SubscriptionPaymentDetailsHealthy") ? "success" : "error"
  }) : /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: 643,
      margin: "auto"
    }
  }, !!expiredPaymentDetailsSubscription && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Alert, {
    showIcon: true,
    type: "error",
    style: {
      margin: "20px 0 10px"
    },
    message: __("The payment method you used for your subscription has expired."),
    description: _i(__("In order for your subscription to continue and for us not to have to collect additional fees on top of the outstanding receivables, {{strong}}we kindly ask you to update your payment method!{{/strong}}"), {
      strong: /*#__PURE__*/React.createElement("strong", null)
    })
  }), /*#__PURE__*/React.createElement(ChangePaymentDetailsForm, {
    record: expiredPaymentDetailsSubscription,
    showInfo: false,
    refetch: false,
    onClose: () => setUpdated(true)
  }))));
});
export { AccountExpiredPaymentDetails };